<template>
  <li>{{ displayMessage }}</li>
</template>
<script>
export default {
  name: 'RegistrationFormValidationMessages',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayMessage: function () {
      const specificKey = `registrationForm.validation.${this.message.propertyPath}.${this.message.code}`
      if (this.$te(specificKey)) {
        return this.$t(specificKey)
      }
      const globalKey = `registrationForm.validation.${this.message.code}`
      return this.$t(globalKey)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/registration-form/ValidationMessage.vue